var LockUnlockStatus = {
  LOCKED: 0,
  UNLOCKED: 1
}

export { LockUnlockStatus }
